import clsx from 'clsx'

const DEFAULT_OPTIONS = {
  hideSwatches: false,
  hidePromolines: false,
  hideBadges: false
}

const SkeletonImage = () => {
  return (
    <div class="relative w-full aspect-4/5 bg-neutral-light overflow-hidden animate-pulse">
    </div>
  )
}

const SkeletonSwatches = () => {
  return (
    <div class="flex gap-x-0.375">
        {
            [1, 2, 3].map((i) => (
                <button key={i} class="size-0.75 bg-neutral-light overflow-hidden" aria-label="Swatch" disabled>
                </button>
            ))
        }
    </div>
  )
}

const SkeletonDetails = () => {
  return (
    <div class="flex flex-col gap-y-0.5">
        <div className={'h-1.125 bg-neutral-light'}></div>
        <div className={'h-1.125 bg-neutral-light'}></div>
    </div>
  )
}

const SkeletonPromolines = () => {
  return (
    <div class="flex flex-col gap-0.25">
        <div className={'w-1/2 h-1.25 bg-neutral-light'}></div>
        <div className={'w-1/2 h-1.25 bg-neutral-light'}></div>
    </div>
  )
}

export const SkeletonCard = ({ className, options = DEFAULT_OPTIONS }) => {
  return (
    <div class={clsx('flex flex-col gap-y-0.625 w-full grow', className)}>
        <SkeletonImage />
        <div class="flex flex-col gap-y-0.5 animate-pulse">
            {!options.hideSwatches && <SkeletonSwatches />}
            <SkeletonDetails />
            {!options.hidePromolines && <SkeletonPromolines />}
        </div>
    </div>
  )
}
